import { styled as t, Box as p } from "@mui/material";
import l from "../../temp-lib/components/share/next/Image.js";
import { noForwardProps as c } from "../../temp-lib/util/styled/index.js";
import u from "../assets/icon-info.svg.js";
import f from "./ApeironSimpleButton.js";
import h from "./ApeironTooltip.js";
import { jsxs as x, jsx as r } from "react/jsx-runtime";
const g = t(p)`
  align-items: center;
  display: flex;
`, b = t(f)`
  border-radius: 100%;
  padding: unset;
  :hover {
    background-color: unset;
  }
  ${(o) => o.theme.breakpoints.up("res1024")} {
    min-width: unset;
  }
  ${(o) => o.theme.breakpoints.down("res1024")} {
    min-width: unset;
  }
`, k = t(l)`
  aspect-ratio: 1;
  width: 20px;
`, C = t(h, c)`
  ${(o) => o.__backgroundColor && `--rt-color-dark:${o.__backgroundColor};`}

  font-size: 12px !important;
  max-width: unset;
`, S = (o) => {
  const {
    backgroundColor: n,
    children: i,
    className: s,
    stay: a,
    tooltipId: e,
    tooltipRef: m,
    place: d
  } = o;
  return /* @__PURE__ */ x(g, {
    className: s,
    children: [/* @__PURE__ */ r(b, {
      className: "Custom-Button",
      "data-tooltip-id": e,
      children: /* @__PURE__ */ r(k, {
        className: "Custom-Button-Icon",
        src: u
      })
    }), /* @__PURE__ */ r(C, {
      __backgroundColor: n,
      id: e,
      stay: a,
      tooltipRef: m,
      place: d,
      children: i
    })]
  });
};
export {
  S as default
};
//# sourceMappingURL=ApeironTooltipInfoButton.js.map
